// removed by extract-text-webpack-plugin
module.exports = {"status":"_2_d2vavFX _1jY4uEptA","status-normal":"_39BcfwOv8 _2_d2vavFX _1jY4uEptA _2UD8zBD74","status-important":"_2zd5FhBIl _2_d2vavFX _1jY4uEptA _7-RsNNCNW","label":"GfY7ssjII _1yJuXbiru mnwpzOKlw _13qojEuKg _3-7RXEMuO _3-BezK0d_ _3FDZP6-k- _1jY4uEptA _5BxAWd9vR _3lHRe10pm _3nV3d_QZu _1RSF8ao01"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/status/status.css
 ** module id = 2174
 ** module chunks = 0
 **/